export default __webpack_public_path__ + "static/media/car.7d515150.svg";